import React, { useEffect, useState } from "react";
import DashboardTopBar from "../../../components/PortalComponents/DashboardTopBar/DashboardTopBar";
import DashboardNavbar from "../../../components/PortalComponents/DashboardNavbar/DashboardNavbar";
import Loading from "../../../components/Loading/Loading";
import { Link } from "react-router-dom";
import { AiOutlineDelete, AiOutlineEye } from "react-icons/ai";
import DashboardNavigation from "../../../components/PortalComponents/DashboardNavigation/DashboardNavigation";
import { api_url } from "../../../url";
import { toast } from "react-toastify";
import axios from "axios";
import parse from "html-react-parser";
import { RotatingLines } from "react-loader-spinner";
import Swal from "sweetalert2";
import NoData from "../../../components/PortalComponents/NoData/NoData";

const WebsiteNews = () => {
  const [loadingNews, setLoadingNews] = useState(true);
  const [newsList, setNewsList] = useState([]);
  const [deletingNews, setDeletingNews] = useState(false);
  
  // Pagination State
  const [count, setCount] = useState(0);
  const [nextUrl, setNextUrl] = useState(null);
  const [prevUrl, setPrevUrl] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Assuming 10 based on standard DRF pagination

  const navigations = ["Dashboard", "News"];

  const getNewsList = async (url = `${api_url}news/`, page = 1) => {
    setLoadingNews(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("access")}`,
      },
    };
    await axios
      .get(url, config)
      .then((response) => {
        setNewsList(response.data.results);
        setCount(response.data.count);
        setNextUrl(response.data.next);
        setPrevUrl(response.data.previous);
        setCurrentPage(page);
        setLoadingNews(false);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Unable to get list. Please refresh page.");
        setLoadingNews(false);
      });
  };

  const deleteNews = async (news_id) => {
    Swal.fire({
      title: `Are you sure?`,
      text: "Once deleted, there is no going back",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setDeletingNews(true);
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `JWT ${localStorage.getItem("access")}`,
          },
        };
        await axios
        .delete(`${api_url}news/${news_id}/`, config)
        .then((response) => {
          Swal.fire({
            icon: "success",
            title: "Deleted",
            text: "News deleted successfully",
          })
            .then(() => {
              // Refresh the current page
              const currentUrl = `${api_url}news/?page=${currentPage}`;
              getNewsList(currentUrl, currentPage);
              setDeletingNews(false);
            })
            .catch((error) => {
              console.error(error);
              setDeletingNews(false);
            });
        }); 
      }
    });
  };

  useEffect(() => {
    getNewsList();
  }, []);

  // Pagination Logic
  const totalPages = Math.ceil(count / itemsPerPage);
  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <div>
      <DashboardTopBar />
      <DashboardNavbar />

      <div className="portal-page">
        <div className="admin-dashboard-title">
          <DashboardNavigation navigations={navigations} />
        </div>
        <div className="section-list">
          <div className="table-section-header">News</div>
          <Link
            to="/portal/admin/website-components/add-news/"
            className="primary-button-outline w-max-content"
            style={{ marginBlock: "5px" }}
          >
            Add News
          </Link>
          {loadingNews ? (
            <Loading />
          ) : (
            <div className="section-list-table">
              <>
                <table>
                  <thead>
                    <tr>
                      <th>Event Date</th>
                      <th>Title</th>
                      <th>Details</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {newsList &&
                      newsList?.map((news, index) => (
                        <tr key={index}>
                          <td>{news.date}</td>
                          <td>{news.title}</td>
                          <td>
                            {parseInt(news.details?.length || 0) > 150 ? (
                              <>{parse(news.details.slice(0, 150))}</>
                            ) : (
                              <>{parse(news.details || "")}</>
                            )}
                          </td>
                          <td>
                            {deletingNews ? (
                              <div style={{ textAlign: "center" }}>
                                <RotatingLines
                                  strokeColor="#021D53"
                                  strokeWidth="5"
                                  animationDuration="0.75"
                                  width="26"
                                  visible={true}
                                />
                              </div>
                            ) : (
                              <div className="action-buttons">
                                <Link
                                  to={`/portal/admin/website-components/news/${news.id}`}
                                  className="view-button"
                                >
                                  View <AiOutlineEye />
                                </Link>
                                <button
                                  onClick={() => deleteNews(news.id)}
                                  className="delete-button"
                                >
                                  Delete <AiOutlineDelete />
                                </button>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {
                  newsList?.length <= 0 && (
                    <NoData />
                  )
                }

                {/* Pagination Controls */}
                {totalPages > 1 && (
                  <div className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6 mt-4">
                    <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                      <div>
                        <p className="text-sm text-gray-700">
                          Showing <span className="font-medium">{(currentPage - 1) * itemsPerPage + 1}</span> to{' '}
                          <span className="font-medium">{Math.min(currentPage * itemsPerPage, count)}</span> of{' '}
                          <span className="font-medium">{count}</span> results
                        </p>
                      </div>
                      <div>
                        <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                          <button
                            onClick={() => prevUrl && getNewsList(prevUrl, currentPage - 1)}
                            disabled={!prevUrl}
                            className={`relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${!prevUrl ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                          >
                            <span className="sr-only">Previous</span>
                            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                              <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd" />
                            </svg>
                          </button>
                          
                          {pageNumbers.map((number) => (
                            <button
                              key={number}
                              onClick={() => getNewsList(`${api_url}news/?page=${number}`, number)}
                              className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold focus:z-20 ${
                                currentPage === number
                                  ? 'z-10 bg-[#021D53] text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#021D53]'
                                  : 'text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0'
                              }`}
                            >
                              {number}
                            </button>
                          ))}

                          <button
                            onClick={() => nextUrl && getNewsList(nextUrl, currentPage + 1)}
                            disabled={!nextUrl}
                            className={`relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0 ${!nextUrl ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
                          >
                            <span className="sr-only">Next</span>
                            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                              <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd" />
                            </svg>
                          </button>
                        </nav>
                      </div>
                    </div>
                  </div>
                )}
              </>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WebsiteNews;
